import jsPDF from "jspdf";
import QRCode from "qrcode";
import sealImage from "../assets/seal.png";
import signatureImage from "../assets/signature.png";

export default async function generateShareCertificate(member) {
  const doc = new jsPDF();

  const drawCertificate = async (type, yStart) => {
    const y = yStart;
    const boxHeight = 135;

    doc.setDrawColor(0);
    doc.setLineWidth(0.3);
    doc.rect(10, y, 190, boxHeight); // Border

    let cursor = y + 10;

    // Header
    doc.setFont("Times", "Bold");
    doc.setFontSize(12);
    doc.setTextColor("#0a3d91");
    doc.text("SHINE AGRI ALLIED AND MARKETING", 105, cursor, { align: "center" });
    cursor += 6;
    doc.text("MULTISTATE COOPERATIVE SOCIETY LIMITED", 105, cursor, { align: "center" });

    cursor += 5;
    doc.setFont("Times", "Normal");
    doc.setFontSize(9);
    doc.setTextColor("black");
    doc.text(
      "48, 1st Floor, Amar Arcade, Nilpur, Ta-Dantiwada, Dist-Banaskantha, Gujarat - 385505",
      105,
      cursor,
      { align: "center" }
    );
    cursor += 4;
    doc.text("Mo. 84908 84020, 93133 99225", 105, cursor, { align: "center" });

    // Title
    cursor += 8;
    doc.setFont("Times", "Bold");
    doc.setFontSize(11);
    doc.text("SHARE CERTIFICATE", 105, cursor, { align: "center" });

    // Copy label
    doc.setFontSize(9);
    doc.text(type === "member" ? "Member's Copy" : "Office Copy", 173, cursor + 18);

    // QR Code
    const qrText = `${member.member_id}\n${member.name}`;
    const qrDataURL = await QRCode.toDataURL(qrText);
    doc.addImage(qrDataURL, "PNG", 170, cursor + 20, 25, 25);

    // Receipt info
    cursor += 14;
    doc.setFont("Times", "Bold");
    doc.setTextColor("black");

    const receiptNo = member.member_id?.slice(-4) || "____";
    const today = new Date();
    const dateStr = `${today.getDate().toString().padStart(2, '0')}/${(
      today.getMonth() + 1
    ).toString().padStart(2, '0')}/${today.getFullYear()}`;

    doc.text(`Receipt No.: ${receiptNo}`, 15, cursor);
    doc.text(`Date: ${dateStr}`, 140, cursor);

    // Body
    cursor += 8;
    const lines = [
      `Received from Shri/Smt. ${member.name.toUpperCase()}`,
      `Membership No.: ${member.member_id}    an amount of Rs. ${member.total || "_____"} `,
      `Rupees in word: ${member.total || "_____"} Rupees Only`,
      `To share capital on ${dateStr} for Shine Agri Allied And Marketing`,
      `Multistate Cooperative Society Limited.`
    ];

    lines.forEach((line) => {
      const wrapped = doc.splitTextToSize(line, 180);
      doc.text(wrapped, 15, cursor);
      cursor += wrapped.length * 6;
    });

    // Seal and Signature
    doc.addImage(sealImage, "PNG", 18, cursor + 2, 30, 30);
    doc.addImage(signatureImage, "PNG", 140, cursor + 10, 40, 18);

    doc.text("Office Seal", 23, cursor + 35);
    doc.text("Authorized Signatory", 145, cursor + 35);
  };

  // Draw two copies
  await drawCertificate("member", 10);
  await drawCertificate("office", 150);

  // Save PDF
  doc.save(`${member.member_id}_ShareCertificate.pdf`);
}
